import { atom } from 'jotai';

/**
 * Global state for showing the token limit exceeded dialog.
 * Stores both visibility and the reset time to display to the user.
 */
export const tokenLimitDialogAtom = atom<{
	isOpen: boolean;
	resetAt: string | null;
}>({
	isOpen: false,
	resetAt: null
});
